import React, { createContext, useContext, useState, useEffect } from "react";
import { getPublicSettings } from "../api/settings";

const SettingsContext = createContext({});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    deposit_percentage: 20,
    company_whatsapp: "+212771373922",
    company_email: "contact@moroccandeserttrek.com",
    company_name: "Moroccan Desert Trek",
    company_phone: "+212771373922",
    company_address: "Merzouga, Morocco",
    currency_symbol: "$",
    max_travelers_per_booking: 20,
    discount_percentage: 0,
    payment_enabled: true,
    hero_images: [],
  });
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await getPublicSettings();
      if (response.data) {
        const data = { ...response.data };
        // Parse hero_images from JSON string if needed
        if (typeof data.hero_images === 'string') {
          try { data.hero_images = JSON.parse(data.hero_images); } catch { data.hero_images = []; }
        }
        // Parse payment_enabled as boolean
        if (typeof data.payment_enabled === 'string') {
          data.payment_enabled = data.payment_enabled === 'true' || data.payment_enabled === '1';
        }
        setSettings((prev) => ({ ...prev, ...data }));
      }
    } catch (err) {
      // Keep defaults on error
    } finally {
      setIsLoaded(true);
    }
  };

  return (
    <SettingsContext.Provider value={{ settings, isLoaded, refreshSettings: loadSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}

export default SettingsContext;
